import React from "react";
import { Spin } from "antd";

import { TorScheduleRow } from "../Commercial/add-plan/api";
import { ViewTORSchedule } from "../schedule/ViewTORSchedule";
import { useTorGrid } from "../Commercial/add-plan/useTorGridData";

interface PreviewTorScheduleProps {
  torScheduleData?: TorScheduleRow[];
  loading?: boolean;
}

export const PreviewTorSchedule = ({ torScheduleData, loading }: PreviewTorScheduleProps) => {
  const { columnDefs, pinnedBottomRowData } = useTorGrid({ torScheduleData });

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "48px 0" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <ViewTORSchedule grandTotalPinnedRow={pinnedBottomRowData} columns={columnDefs} rows={torScheduleData} />
    </div>
  );
};
